const store = {
    namespaced: true,
    state() {
        return {
            isModalOrderCheckout: false,
            modals: [],
            opened: []
        };
    },
    getters: {
        opened: state => state.opened,
        isModalOrderCheckout: state => state.isModalOrderCheckout,
        // getModals: state => {
        //     return state.modals;
        // },
        getModals: (state, getters, rootState, rootGetters) => rootGetters['global/getPopupsConfigurations'],
        getModalByKey: (state, getters, rootState, rootGetters) => key => {
            const modals = rootGetters['global/getPopupsConfigurations'];

            return modals.find(modal => modal.key.key === key);
        }
    },
    mutations: {
        OPEN: (state, name) => state.opened.push(name),
        CLOSE: state => state.opened.splice(0),
        SET_IS_MODAL_CHECKOUT: (state, flag) => (state.isModalOrderCheckout = flag),
        SET_MODALS: (state, data) => (state.modals = data)
    },
    actions: {
        open: ({ commit }, name) => {
            commit('CLOSE');
            commit('OPEN', name);
        },
        close: ({ commit }) => commit('CLOSE'),
        setIsModalCheckout: async function ({ commit }, flag) {
            commit('SET_IS_MODAL_CHECKOUT', flag);
        },
        setModals: async function ({ commit }, data) {
            commit('SET_MODALS', data);
        }
    }
};

export default store;
